(() => {
  'use strict';

  const init = (root) => {
    if (root.__am) return;
    const track = root.querySelector('[data-am-track]');
    if (!track) return;
    root.__am = true;

    const groups = [...track.querySelectorAll('.am__group')];
    const pxPerSec = Math.max(10, Number(root.dataset.speed) || 50);
    let lastWidth = 0;

    // Make each group at least as wide as the screen (so there is never a gap),
    // then set the duration so the speed is the same on every device.
    const layout = () => {
      const vw = root.clientWidth;
      const first = groups[0].querySelector('.am__set');
      const setW = first ? first.getBoundingClientRect().width : 0;
      if (!setW || !vw) return;

      const need = Math.max(1, Math.ceil(vw / setW));
      groups.forEach((g, gi) => {
        while (g.children.length < need) {
          const clone = g.firstElementChild.cloneNode(true);
          clone.setAttribute('aria-hidden', 'true');
          g.appendChild(clone);
        }
        while (g.children.length > need) g.lastElementChild.remove();
      });

      const groupW = groups[0].getBoundingClientRect().width;
      root.style.setProperty('--am-duration', (groupW / pxPerSec).toFixed(2) + 's');
    };

    let raf = 0;
    const schedule = () => {
      cancelAnimationFrame(raf);
      raf = requestAnimationFrame(() => {
        const w = root.clientWidth;
        if (w === lastWidth) return;
        lastWidth = w;
        layout();
      });
    };

    layout();
    lastWidth = root.clientWidth;

    if ('ResizeObserver' in window) new ResizeObserver(schedule).observe(root);
    else window.addEventListener('resize', schedule, { passive: true });

    // Fonts can change text width after first paint
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(() => { lastWidth = 0; schedule(); });
  };

  const run = (scope = document) => scope.querySelectorAll('[data-am]').forEach(init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => run());
  else run();
  document.addEventListener('shopify:section:load', (e) => run(e.target));
})();